export default (params) => ({
  trigger: {
    name: 'order_block.add_to_wishlist',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'add_to_wishlist',
      params: {
        sub_feature: null,
      },
    },
  },
});
